import hoistNonReactStatics from 'hoist-non-react-statics';
import React from 'react';

/**
 * Returns the display name of a React component, falling back appropriately.
 */
var getDisplayName = function getDisplayName(component) {
  return (component === null || component === void 0 ? void 0 : component.displayName) || (component === null || component === void 0 ? void 0 : component.name) || (typeof component === 'string' && component.length > 0 ? component : undefined) || 'Component';
};
var mapProps = function mapProps(getProps) {
  return function (NextComponent) {
    var MapProps = function MapProps(props) {
      return /*#__PURE__*/React.createElement(NextComponent, getProps(props));
    };
    hoistNonReactStatics(MapProps, NextComponent);
    MapProps.displayName = "MapProps(".concat(getDisplayName(NextComponent), ")");
    return MapProps;
  };
};
export { getDisplayName, mapProps };